import ConsumerPanel from './consumerPanel.container';

export default ConsumerPanel;